import {
    QueryFilters,
    useActiveResourcesPreview,
    useActiveUsersPreview,
    useAllAuthenticationsTraffic,
    useAuthenticationTypeSummary,
    useBridgeMfaPolicies,
    useMedianMfa,
    useMfaAuthentications,
    useMfaPolicies,
    useMfaResponse,
    useMfaTriggerRate,
    usePolicyType,
    useProtectedUsers,
    useProtocolTypeSummary,
    useRiskyIndicators,
    useRiskyResources,
    useRiskyUsers,
    useTokenDistributionSummary,
    useTopDailyMfa
} from '../api';

const useUniversalMfaMetrics = (filters: QueryFilters) => {
    const domainFilterOnly = { domain: filters.domain };

    const { data: mfaPolicies, isLoading: mfaPoliciesIsLoading } = useMfaPolicies();
    const { data: policyType, isLoading: policyTypeIsLoading } = usePolicyType();
    const { data: bridgeMfaPolicies, isLoading: bridgeMfaPoliciesIsLoading } = useBridgeMfaPolicies();

    const { data: protectedUsers, isLoading: protectedUsersIsLoading } = useProtectedUsers(domainFilterOnly);
    const { data: riskyUsers, isLoading: riskyUsersIsLoading } = useRiskyUsers(domainFilterOnly);
    const { data: riskyResources, isLoading: riskyResourcesIsLoading } = useRiskyResources(domainFilterOnly);
    const { data: riskyIndicators, isLoading: riskyIndicatorsIsLoading } = useRiskyIndicators(domainFilterOnly);
    const { data: activeUsers, isLoading: activeUsersIsLoading } = useActiveUsersPreview(domainFilterOnly);
    const { data: activeResources, isLoading: activeResourcesIsLoading } = useActiveResourcesPreview(domainFilterOnly);

    const { data: medianMfa, isLoading: medianMfaIsLoading } = useMedianMfa(filters);
    const { data: mfaResponse, isLoading: mfaResponseIsLoading } = useMfaResponse(filters);
    const { data: mfaTriggerRate, isLoading: mfaTriggerRateIsLoading } = useMfaTriggerRate(filters);
    const { data: mfaAuthentications, isLoading: mfaAuthenticationsIsLoading } = useMfaAuthentications(filters);
    const { data: mfaAllAuthenticationsTraffic, isLoading: mfaAllAuthenticationsTrafficIsLoading } =
        useAllAuthenticationsTraffic(filters);
    const { data: authenticationTypeSummary, isLoading: authenticationTypeSummaryIsLoading } =
        useAuthenticationTypeSummary(filters);
    const { data: protocolTypeSummary, isLoading: protocolTypeSummaryIsLoading } = useProtocolTypeSummary(filters);
    const { data: tokenDistributionSummary, isLoading: tokenDistributionSummaryIsLoading } =
        useTokenDistributionSummary(filters);
    const { data: topDailyMfa, isLoading: topDailyMfaIsLoading } = useTopDailyMfa(filters);

    return {
        mfaPolicies,
        mfaPoliciesIsLoading,
        protectedUsers,
        protectedUsersIsLoading,
        policyType,
        policyTypeIsLoading,
        medianMfa,
        medianMfaIsLoading,
        bridgeMfaPolicies,
        bridgeMfaPoliciesIsLoading,
        mfaResponse,
        mfaResponseIsLoading,
        mfaTriggerRate,
        mfaTriggerRateIsLoading,
        mfaAuthentications,
        mfaAuthenticationsIsLoading,
        mfaAllAuthenticationsTraffic,
        mfaAllAuthenticationsTrafficIsLoading,
        authenticationTypeSummary,
        authenticationTypeSummaryIsLoading,
        protocolTypeSummary,
        protocolTypeSummaryIsLoading,
        tokenDistributionSummary,
        tokenDistributionSummaryIsLoading,
        topDailyMfa,
        topDailyMfaIsLoading,
        activeUsers,
        activeUsersIsLoading,
        activeResources,
        activeResourcesIsLoading,
        riskyUsers,
        riskyUsersIsLoading,
        riskyResources,
        riskyResourcesIsLoading,
        riskyIndicators,
        riskyIndicatorsIsLoading
    };
};

export default useUniversalMfaMetrics;
